module.exports = __webpack_public_path__ + "prod/20260714105240/img/service.edbff227.png";